(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Ricerca in testata mobile: riusa la modale gia' esistente, con /search come
     ripiego se il JS della modale non e' ancora pronto. */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-mtop-search]');
    if(!b) return;
    e.preventDefault();
    if(window.AMES_SEARCH_MODAL && window.AMES_SEARCH_MODAL.open) window.AMES_SEARCH_MODAL.open();
    else location.href = (window.AMES_ROOT || '/').replace(/\/$/,'') + '/search';
  });

  /* Segna la macro-categoria in cui ci si trova: la strip mostrava sette voci
     tutte uguali, senza dire dove sei. */
  (function markCurrent(){
    var here = location.pathname.replace(/\/+$/,'');
    document.querySelectorAll('.ames-mstory').forEach(function(a){
      var href = (a.getAttribute('href')||'').replace(/\/+$/,'');
      if(href && href !== '/' && here.indexOf(href) === 0) a.classList.add('is-current');
    });
  })();

  function q(s){return document.querySelector(s);}
  var drawer=q('#ames-drawer'), scrim=q('.ames-scrim'), daDove=null;
  function burgers(v){ document.querySelectorAll('.ames-burger').forEach(function(b){ b.setAttribute('aria-expanded', v); b.setAttribute('aria-controls','ames-drawer'); }); }
  burgers('false');
  function open(){
    if(!drawer) return;
    daDove=document.activeElement;
    drawer.removeAttribute('inert'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    if(scrim)scrim.classList.add('open');
    document.documentElement.classList.add('ames-drawer-aperto'); burgers('true');
    var c=drawer.querySelector('.ames-drawer__close'); if(c) setTimeout(function(){ c.focus({preventScroll:true}); }, 60);
  }
  function close(){
    if(!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); drawer.setAttribute('inert','');
    if(scrim)scrim.classList.remove('open');
    document.documentElement.classList.remove('ames-drawer-aperto'); burgers('false');
    if(daDove && daDove.focus) daDove.focus({preventScroll:true});
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-drawer-open]')){e.preventDefault();open();}
    else if(e.target.closest('[data-drawer-close]')){close();}
    else if(e.target.closest('[data-ames-open-quote]')&&window.AMES_QUOTE_M){e.preventDefault();window.AMES_QUOTE_M.open();}
    else if(e.target.closest('[data-ames-open-compare]')&&window.AMES_CMP){e.preventDefault();window.AMES_CMP.open();}
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape')close(); });
})();

  } catch(e) { console.error(e); }
})();
})();
